import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg
    id="Group_1080"
    data-name="Group 1080"
    viewBox="0 0 170.427 184.061"
    ref={svgRef}
    {...props}
  >
    <title>
      Hands holding a heart illustration
    </title>
    <defs>
      <style>{`.cls-1{fill:#d9d9d6}.cls-2{fill:#218ece}`}</style>
    </defs>


    <path
      id="heart-left-side"
      data-name="Path 351"
      className="cls-2"
      d="M63.139,12.431,60.332,9.624A30.637,30.637,0,0,0,7.4,30.476a29.668,29.668,0,0,0,9.624,22.055L33.866,69.374,58.728,94.236l4.411,3.716"
      transform="translate(22.274)"
    />
    <path
      id="heart-right-side"
      data-name="Path 352"
      d="M24.508,94.637,49.37,69.775,66.212,52.932a29.669,29.669,0,0,0,9.624-22.055A29.812,29.812,0,0,0,24.107,9.624L21.3,12.431V97.845Z"
      transform="translate(64.114)"
      fill="#0061a0"
    />
    <g id="left-hand">
      <path
        id="Path_347"
        data-name="Path 347"
        className="cls-1"
        d="M16.842 31.452l.4 24.862L41.7 79.572a2.981 2.981 0 1 0 4.01-4.411l-9.62-9.223a8.625 8.625 0 0 1-1.6-11.228 9.013 9.013 0 0 1 13.634-1.6l20.448 19.645A23.09 23.09 0 0 1 75.79 89.2l.4 15.238.4 8.421.4 22.055-49.722-15.242-.4-17.243a10.1 10.1 0 0 0-3.609-8.02L4.812 76.765a10.687 10.687 0 0 1-3.612-8.02L0 15.411a16.272 16.272 0 0 1 16.842 16.04"
        transform="translate(0 46.343)"
      />
      <path
        id="Path_348"
        data-name="Path 348"
        className="cls-2"
        d="M5.2 36.4l56.14 13.233.4 24.862L5.6 61.262z"
        transform="translate(15.652 109.565)"
      />
    </g>
    <g id="right-hand">
      <path
        id="Path_349"
        data-name="Path 349"
        className="cls-1"
        d="M83.751 31.183l-.8 24.862L58.488 79.3a2.981 2.981 0 1 1-4.01-4.411l9.622-9.22a8.625 8.625 0 0 0 1.6-11.228 9.013 9.013 0 0 0-13.634-1.6L31.621 72.486A23.09 23.09 0 0 0 24.4 88.927l-.4 15.238-.4 8.421-.4 22.055L73.325 119.4l.4-17.243a10.1 10.1 0 0 1 3.609-8.02L95.782 76.5a10.687 10.687 0 0 0 3.609-8.02l1.2-52.932a15.71 15.71 0 0 0-16.84 15.635"
        transform="translate(69.833 46.612)"
      />
      <path
        id="Path_350"
        data-name="Path 350"
        className="cls-2"
        d="M79.741 36.4L23.6 49.633 23.2 74.5l56.14-13.238z"
        transform="translate(69.833 109.565)"
      />
    </g>
  </svg>
)

const QuestionsSVG = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))

export default QuestionsSVG
